import * as firebase from 'firebase'
import config from '../Config/FirebaseConfig'

const firebaseApp = firebase.initializeApp(config)

const db = firebaseApp.database()

export const ref = function (ref) {
  return db.ref(ref)
}

export const generateKey = function (ref) {
  return db.ref(ref).push().key
}

export const getTimestamp = function () {
  return firebase.database.ServerValue.TIMESTAMP
}

export const add = function (ref, data) {
  const addRef = db.ref(ref)
  return addRef.push(data).key
}

export const get = function (ref) {
  const source = ref ? db.ref(ref) : db.ref()
  return new Promise(function (resolve, reject) {
    source.once('value')
      .then(function (snapshot) {
        resolve({
          key: snapshot.key,
          value: snapshot.val()
        })
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

export const update = function (ref, data) {
  const updateRef = db.ref(ref)
  return updateRef.update(data)
}

export const remove = function (ref) {
  const deleteRef = db.ref(ref)
  deleteRef.remove()
}



// WEBPACK FOOTER //
// ./src/Services/Firebase.js